<template>
  <div class="page-wrapper grid-lines">
    <Header v-on:toggleMobileMenu="toggleMobileMenu" />
    <main
      class="min-h-screen bg-center"
      :class="{
        'bg-transparent h-screen': !gotData,
        'blur-sm md:blur-none': mobileMenuOpen,
      }"
    >
      <!-- <div v-if="!subscriptionType" id="coupon-banner" class="border-b-2 border-black bg-gray-200 text-black text-center py-2">
        <p class="text-sm">
          <span class="font-bold">LIMITED TIME ONLY - USE CODE <span class="text-blue-700 font-extrabold">SPRING20</span> AT
          <a
            href="/signup/quarterly"
            class="underline"
            >CHECKOUT</a
          > FOR 20% OFF </span>
        </p>
      </div> -->
      <Intro
        v-if="!subscriptionType"
        :nextMatch="nextMatch"
        :nextMatchTime="APIData.commencing"
        :totalCorrectMatches="APIData.total_correct_matches"
      />

      <div class="bg-white" v-else-if="subscriptionType != 'active'">
        <div class="border-brandGrey">
          <section class="max-w-6xl mx-auto px-4 pt-16 relative bg-white">
            <SubscriberIntro
              :numberOfMatches="numberMatches"
              :numberOfCompetitions="numberCompetitions"
              :subscriptionType="subscriptionType"
            ></SubscriberIntro>
            <div
              class="flex inset-0 items-center justify-center inline-block relative pb-8"
            >
              <router-link
                to="/signup/"
                class="inline-flex bg-white underline items-center justify-center text-xs p-3 px-6 font-bold uppercase text-blue-700"
              >
                Subscribe to access all games
              </router-link>
            </div>
          </section>
        </div>
      </div>
      <SubscriberIntro
        class="py-4"
        v-if="subscriptionType == 'active'"
        :numberOfMatches="numberMatches"
        :numberOfCompetitions="numberCompetitions"
        :subscriptionType="subscriptionType"
      />
      <p
        v-if="subscriptionType == 'active' && leaguePrefsNote"
        class="max-w-6xl mx-auto px-4 pb-3 text-center text-xs text-gray-500"
      >
        <template v-if="leaguePrefsNote == 'showing'">
          Showing your leagues ({{ leaguesToShowData.length }}) ·
          <button class="text-blue-700 underline" v-on:click="showAllLeagues">
            Show all leagues
          </button>
        </template>
        <template v-else>
          None of your leagues have matches right now, so every league is
          showing.
        </template>
        ·
        <router-link to="/account" class="text-blue-700 underline"
          >Change</router-link
        >
      </p>
      <p
        v-if="subscriptionType == 'active'"
        class="max-w-6xl mx-auto px-4 pb-3 text-center text-xs text-gray-500"
      >
        Tap <span class="font-semibold">+</span> next to a prediction to add it
        to your slip ·
        <button class="text-blue-700 underline" v-on:click="openSlip">
          Build me a slip
        </button>
      </p>
      <section
        v-if="emailMatch"
        ref="emailMatch"
        class="max-w-6xl mx-auto px-4 py-10 text-center"
      >
        <h3 class="mb-4 text-base text-brandGrey">The match from your email</h3>
        <div class="md:flex justify-center">
          <FreemiumCard
            class="blur-freemium"
            mode="chrono"
            :match="emailMatch"
            :competition="emailMatch.competition"
          />
        </div>
        <router-link
          to="/signup"
          class="email-cta inline-flex mt-6 items-center justify-center p-3 px-6 font-bold uppercase text-white shadow-xl"
        >
          Subscribe to access
        </router-link>
      </section>
      <span id="matches"></span>
      <template v-if="gotData && APIData.length">
        <template
          v-if="subscriptionType == 'active' || subscriptionType == 'inactive'"
        >
          <div class="relative">
            <form
              v-click-outside="hideMobileSearch"
              class="absolute z-40 left-4 top-2 min-w-[36px] min-h-[36px] md:right-auto"
              :class="{ 'right-4': !mobileSearchHidden }"
              v-on:submit.prevent
              v-if="subscriptionType == 'active'"
            >
              <input
                type="text"
                placeholder="SEARCH..."
                ref="focusSearch"
                v-model="searchValue"
                class="border border-white bg-gray-200/30 rounded-full p-2 px-4 text-base md:text-sm md:block w-full"
                :class="{ hidden: mobileSearchHidden }"
              />
              <button
                type="submit"
                v-on:click="toggleMobileSearchOrSubmit"
                class="absolute right-0 top-0 p-2 text-blue-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  class="w-5 h-5"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                  />
                </svg>
              </button>
            </form>
            <div
              class="absolute z-20 left-4 sm:left-auto right-4 top-1 flex justify-end"
              :class="{ 'hidden md:flex': !mobileSearchHidden }"
            >
              <!-- <button
                v-on:click="scrollToNextGame"
                v-if="!showFilters"
                class="uppercase p-2 flex text-blue-700 font-bold underline items-center justify-center"
              >
                Jump to next game
                <svg
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <mask
                    id="mask0_323_372"
                    style="mask-type:alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="21"
                    height="20"
                  >
                    <rect
                      x="0.815979"
                      width="19.368"
                      height="19.368"
                      fill="url(#pattern0)"
                    />
                  </mask>
                  <g mask="url(#mask0_323_372)">
                    <rect
                      x="4.10856"
                      y="2.03364"
                      width="12.6861"
                      height="13.3639"
                      fill="#0000EE"
                    />
                  </g>
                  <defs>
                    <pattern
                      id="pattern0"
                      patternContentUnits="objectBoundingBox"
                      width="1"
                      height="1"
                    >
                      <use
                        xlink:href="#image0_323_372"
                        transform="scale(0.005)"
                      />
                    </pattern>
                    <image
                      id="image0_323_372"
                      width="200"
                      height="200"
                      xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAMP2lDQ1BJQ0MgUHJvZmlsZQAASImVVwdYU8kWnluSkJDQAghICb0JIjWAlBBaAOndRkgChBJjIKjYkUUF14KKBWzoqohip9kRO4ti74sFFWVdLNiVNymg677yvfm+ufPff87858y5M/feAUD9OFcszkU1AMgTFUhiQwIYySmpDNJTQAIYoAJHYMLl5YtZ0dERAJbB9u/l3XWAyNorDjKtf/b/16LJF+TzAECiIU7n5/PyID4AAF7NE0sKACDKePMpBWIZhhVoS2CAEC+Q4UwFrpbhdAXeI7eJj2VD3AaACpXLlWQCoHYJ8oxCXibUUOuD2EnEF4oAUGdA7JuXN4kPcRrENtBGDLFMn5n+g07m3zTThzS53MwhrJiLvKgECvPFudxp/2c6/nfJy5UO+rCClZolCY2VzRnm7WbOpHAZpkLcK0qPjIJYC+IPQr7cHmKUkiUNTVDYo4a8fDbMGdCF2InPDQyH2BDiYFFuZISST88QBnMghisEnSos4MRDrAfxAkF+UJzSZqNkUqzSF9qQIWGzlPxZrkTuV+brvjQngaXUf50l4Cj1MbWirPgkiCkQWxQKEyMhVoPYMT8nLlxpM7ooix05aCORxsrit4A4ViAKCVDoY4UZkuBYpX1ZXv7gfLGNWUJOpBLvK8iKD1XkB2vjceXxw7lglwQiVsKgjiA/OWJwLnxBYJBi7tgzgSghTqnzQVwQEKsYi1PEudFKe9xMkBsi480gds0vjFOOxRML4IJU6OMZ4oLoeEWceFE2NyxaEQ++FEQANggEDCCFNR1MAtlA2NHb2AvvFD3BgAskIBMIgIOSGRyRJO8RwWscKAJ/QiQA+UPjAuS9AlAI+a9DrOLqADLkvYXyETngCcR5IBzkwnupfJRoyFsieAwZ4T+8c2HlwXhzYZX1/3t+kP3OsCAToWSkgx4Z6oOWxCBiIDGUGEy0xQ1wX9wbj4BXf1idcSbuOTiP7/aEJ4ROwkPCNUIX4dZEYbHkpyjHgC6oH6zMRfqPucCtoKYbHoD7QHWojOviBsABd4V+WLgf9OwGWbYybllWGD9p/20GPzwNpR3ZiYySh5H9yTY/j1SzU3MbUpHl+sf8KGJNH8o3e6jnZ//sH7LPh234z5bYAmw/dgY7gZ3DDmONgIEdw5qwduyIDA+trsfy1TXoLVYeTw7UEf7D3+CTlWUy36nOqcfpi6KvQDBV9o4G7EniaRJhZlYBgwW/CAIGR8RzHMFwdnJ2AUD2fVG8vt7EyL8biG77d27eHwD4HBsYGDj0nQs7BsBeD7j9m79zNkz46VAF4GwzTyopVHC47EKAbwl1uNP0gTEwBzZwPs7AHXgDfxAEwkAUiAcpYAKMPguucwmYAmaAuaAUlIOlYCVYCzaAzWA72AX2gUZwGJwAp8EFcAlcA3fg6ukGL0AfeAc+IwhCQmgIHdFHTBBLxB5xRpiILxKERCCxSAqShmQiIkSKzEDmIeVIBbIW2YTUInuRZuQEcg7pRG4hD5Ae5DXyCcVQKqqNGqFW6EiUibLQcDQeHY9mopPRIrQEXYyuRmvQnWgDegK9gF5Du9AXaD8GMFVMFzPFHDAmxsaisFQsA5Ngs7AyrBKrweqxFvicr2BdWC/2ESfidJyBO8AVHIon4Dx8Mj4LX4SvxbfjDXgbfgV/gPfh3wg0giHBnuBF4BCSCZmEKYRSQiVhK+Eg4RTcS92Ed0QiUZdoTfSAezGFmE2cTlxEXEfcTTxO7CQ+IvaTSCR9kj3JhxRF4pIKSKWkNaSdpGOky6Ru0gcVVRUTFWeVYJVUFZFKsUqlyg6VoyqXVZ6qfCZrkC3JXuQoMp88jbyEvIXcQr5I7iZ/pmhSrCk+lHhKNmUuZTWlnnKKcpfyRlVV1UzVUzVGVag6R3W16h7Vs6oPVD9Stah2VDZ1HFVKXUzdRj1OvUV9Q6PRrGj+tFRaAW0xrZZ2knaf9kGNruaoxlHjq81Wq1JrULus9lKdrG6pzlKfoF6kXqm+X/2ieq8GWcNKg63B1ZilUaXRrHFDo1+TrjlKM0ozT3OR5g7Nc5rPtEhaVlpBWnytEq3NWie1HtExujmdTefR59G30E/Ru7WJ2tbaHO1s7XLtXdod2n06WjquOok6U3WqdI7odOliula6HN1c3SW6+3Sv634aZjSMNUwwbOGw+mGXh73XG67nryfQK9PbrXdN75M+Qz9IP0d/mX6j/j0D3MDOIMZgisF6g1MGvcO1h3sP5w0vG75v+G1D1NDOMNZwuuFmw3bDfiNjoxAjsdEao5NGvca6xv7G2cYrjI8a95jQTXxNhCYrTI6ZPGfoMFiMXMZqRhujz9TQNNRUarrJtMP0s5m1WYJZsdlus3vmFHOmeYb5CvNW8z4LE4sxFjMs6ixuW5ItmZZZlqssz1i+t7K2SrKab9Vo9cxaz5pjXWRdZ33XhmbjZzPZpsbmqi3RlmmbY7vO9pIdaudml2VXZXfRHrV3txfar7PvHEEY4TlCNKJmxA0HqgPLodChzuGBo65jhGOxY6Pjy5EWI1NHLht5ZuQ3JzenXKctTndGaY0KG1U8qmXUa2c7Z55zlfNVF5pLsMtslyaXV672rgLX9a433ehuY9zmu7W6fXX3cJe417v3eFh4pHlUe9xgajOjmYuYZz0JngGesz0Pe370cvcq8Nrn9Ze3g3eO9w7vZ6OtRwtGbxn9yMfMh+uzyafLl+Gb5rvRt8vP1I/rV+P30N/cn++/1f8py5aVzdrJehngFCAJOBjwnu3Fnsk+HogFhgSWBXYEaQUlBK0Nuh9sFpwZXBfcF+IWMj3keCghNDx0WegNjhGHx6nl9IV5hM0MawunhseFrw1/GGEXIYloGYOOCRuzfMzdSMtIUWRjFIjiRC2PuhdtHT05+lAMMSY6pirmSeyo2BmxZ+LocRPjdsS9iw+IXxJ/J8EmQZrQmqieOC6xNvF9UmBSRVJX8sjkmckXUgxShClNqaTUxNStqf1jg8auHNs9zm1c6bjr463HTx1/boLBhNwJRyaqT+RO3J9GSEtK25H2hRvFreH2p3PSq9P7eGzeKt4Lvj9/Bb9H4COoEDzN8MmoyHiW6ZO5PLMnyy+rMqtXyBauFb7KDs3ekP0+JypnW85AblLu7jyVvLS8ZpGWKEfUNsl40tRJnWJ7cam4a7LX5JWT+yThkq35SP74/KYCbfgj3y61kf4ifVDoW1hV+GFK4pT9UzWniqa2T7ObtnDa06Lgot+m49N501tnmM6YO+PBTNbMTbOQWemzWmebzy6Z3T0nZM72uZS5OXN/L3Yqrih+Oy9pXkuJUcmckke/hPxSV6pWKim9Md97/oYF+ALhgo6FLgvXLPxWxi87X+5UXln+ZRFv0flfR/26+teBxRmLO5a4L1m/lLhUtPT6Mr9l2ys0K4oqHi0fs7xhBWNF2Yq3KyeuPFfpWrlhFWWVdFXX6ojVTWss1ixd82Vt1tprVQFVu6sNqxdWv1/HX3d5vf/6+g1GG8o3fNoo3HhzU8imhhqrmsrNxM2Fm59sSdxy5jfmb7VbDbaWb/26TbSta3vs9rZaj9raHYY7ltShddK6np3jdl7aFbirqd6hftNu3d3le8Ae6Z7ne9P2Xt8Xvq91P3N//QHLA9UH6QfLGpCGaQ19jVmNXU0pTZ3NYc2tLd4tBw85Htp22PRw1RGdI0uOUo6WHB04VnSs/7j4eO+JzBOPWie23jmZfPJqW0xbx6nwU2dPB58+eYZ15thZn7OHz3mdaz7PPN94wf1CQ7tb+8Hf3X4/2OHe0XDR42LTJc9LLZ2jO49e9rt84krgldNXOVcvXIu81nk94frNG+NudN3k33x2K/fWq9uFtz/fmXOXcLfsnsa9yvuG92v+sP1jd5d715EHgQ/aH8Y9vPOI9+jF4/zHX7pLntCeVD41eVr7zPnZ4Z7gnkvPxz7vfiF+8bm39E/NP6tf2rw88Jf/X+19yX3drySvBl4veqP/Zttb17et/dH999/lvfv8vuyD/oftH5kfz3xK+vT085QvpC+rv9p+bfkW/u3uQN7AgJgr4cp/BTBY0YwMAF5vA4CWAgAdns8oYxXnP3lBFGdWOQL/CSvOiPLiDkA9/H+P6YV/NzcA2LMFHr+gvvo4AKJpAMR7AtTFZagOntXk50pZIcJzwMbQr+l56eDfFMWZ84e4f26BTNUV/Nz+C3wNfGVregoDAAAAOGVYSWZNTQAqAAAACAABh2kABAAAAAEAAAAaAAAAAAACoAIABAAAAAEAAADIoAMABAAAAAEAAADIAAAAALiTH68AAAjqSURBVHgB7Z2/i1RXFMfXoIKwKFgoIooGXY1WQtKJBhSrQAyxMIhFmvwtVhY2goFgG0hiJYIIKtaxSlADIogaGysVhYDJ9xIf+3Z2Z3Z23v1xzr2fB4c38+a9e8/9nPPZ+eWuc3NsEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAgEsC61xmPX3Se3XqKcUBxSbFK8V9xU3FGwXb9AS26NTA8ohiq+Kd4qEisHyiYHNE4LByvaH4d0y81vELinkF22QCm/XwRcVbxTie1/XYIQWbAwLnleN7xbhi9o8/0nn7HKypVIoHNfFjRZ/ZuNuB+blSiTLvdATO6rRxBRx3/IWuWZhu+KbO+kyrfakYx22l4x90/pmmKDla7B7lOullwEoF7Y4hydJCzyJHxzK8fN21dDjuWSBwVUl0RZpljyT/V3GIHB33KxYaghwWCYQ32+FTla5As+5blySGHIF9eCbfpGAzQuCk8phVitHrWpUklhwdz+NGemNQGp8MutrOxZ9GTGWHxrqjWIg4pvWhghy3FdsjJhqzJhHTWttQtQiyfm3LXvXsliRJIUcAvGFVyg5OqEWQvxOwbkGSVHKEcoSXqmxGCOxUHt1r39j7Wt+TxH7P0ecevg/ZZqQ3SOMjgbva94sU8/ZzjV3Te5KUcgTutz7WhJ0hAieUS0wpRseqRZLUcgRuxwz1Ban0CFzW7dHGjnnfuyQ55LjUqwc3jREIn5xcU8SUYnQsr5LkkOMXsY/9iaKxFvOfzkYtAUmW1jGXHOEHFJsDAkiyWCTkWGTBrR4BJJmbQ45eQ3BzOYGWJUGO5f3AkRUI5JJk/wpzlzqEHKXIO523JUmQw2mTlk67BUmQo3SXOZ+/ZkmQw3lzWkm/RkmQw0p3VZJHTZIgRyVNaW0ZNUiCHNa6qrJ8PEuCHJU1o9XleJQEOax2U6V5eZIEOSptQuvLyiHJM0EY8o07cljvosrzsywJclTefF6WZ1ES5PDSPY3kaUkS5Gik6bwt04IkyOGtaxrLt6QkyNFYs3ldbglJkMNrtzSad05JkKPRJvO+7FySrPW/PRv9s0Sr3Q9/moe/PuK9G43mn0OS1Rp8yOPIYbSxakrLqyTIUVMXGl+LN0mQw3hD1ZieF0mQo8buc7Im65Igh5NGqjlNq5IgR81d52xt1iRBDmcN1EK6ViRBjha6zekaS0uCHE4bp6W0S0mCHC11mfO15pYEORI1zLpE41oZdq8SOaU4oNikeKW4r7ipeKNIuQVJflacTjmJxv5V8Z3in8TzbNH4geURxVbFO8VDRWD5RMHmiMBh5XpDMe7fLb3WYxcU84qUW+pnkhzPHJsF6KLirWIcz+t67JCCzQGB88rxvWJcMfvHH+m8fYnXlEqSHHIcFJvHU7IMzM8lZsnwAwmc1fV9Aaa5/ULXLAycd7XLY0uSQ45Zfi/lg0CcWQ0Gj5chsEfTTnoZMEkWT5JYlaPjG16+7irTAsw6icBVPdgVaZa9B0msy9FxvzKpUDyWn8C8pgyfqnQFmnVvWRIvcgT24Zk8fGrIZoTASeUxqxSj1+WQJPzK609ryDn8RE79a7KzvOcYZde/f1w5sxkh8IPy6Bdn6O0ckoTvoL5VPJiQ+x967GtF6i22HIH/96mTzjH++hyTZJgj9jp2KOc7ii8VfylSbKGJwpd8vyk+VxxV7FaE408V9xThS81wP+UW5Lit2B55ktTPeJHTrXu4b7S80EixI8czScnKpHjm6GrwVcmFMfdSAjt1tytM7H2tkqSUI3wfsm1pibhXmsBdJRBbjm685xp7ofQCI86fUo7A7FbEXBkqEoETGqdr6BT7WiRJLUdgfyxSTRkmMoHLGi+FHN2Y3iXJIcelyDVluIgEwicn1xRdQ6fYe5Ukhxzhy8zYnyhGbA+GCgQ2KpBkaS/kkiP8gGJzQABJFouEHIssuNUjgCRzc8jRawhuLifQsiTIsbwfOLICgVyS7F9h7lKHkKMUeafztiQJcjht0tJptyAJcpTuMufz1ywJcjhvTivp1ygJcljprkryqEkS5KikKa0towZJkMNaV1WWj2dJkKOyZrS6HI+SIIfVbqo0L0+SIEelTWh9WTkkeSYIQ75xRw7rXVR5fpYlQY7Km8/L8ixKghxeuqeRPC1JghyNNJ23ZVqQBDm8dU1j+ZaUBDkaazavyy0hCXJ47ZZG884pCXI02mTel51LkpcCleLPFXVj5vh/RrzXmvxnJJBDkq6RU+yRY8bCc9n0BLxKghzT15gzBxLwJglyDCw4l6+dgBdJkGPtteWKSASsS4IckQrNMLMTsCoJcsxeU66MTMCaJMgRucAMN5yAFUmQY3gtGSERgdKSIEeiwjJsPAKlJEGOeDVkpMQEckuCHIkLyvDxCeSSBDni144RMxFILQlyZCok06QjkEoS5EhXM0bOTCC2JMiRuYBMl55ALEmQI32tmKEQgaGSIEehwjFtPgKzSoIc+WrETIUJbND8VxXT/tbgjzo3XMMGgWYIrNNKzygeKMaJ8qceO61gK0QgFImtLIFQgy8URxW7FUGWp4p7it8/3teODQIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABKYm8B8JBSWvybJHeAAAAABJRU5ErkJggg=="
                    />
                  </defs>
                </svg>
              </button> -->

              <FiltersWrapper
                v-if="subscriptionType == 'active'"
                @getToday="getToday"
                @getLeagues="getLeagues"
                @getChrono="getChrono"
                @bubbleFilters="bubbleFilters"
                @fractionalOdds="fractionalOdds"
                :sortByMode="mode"
                @decimalOdds="decimalOdds"
                @chosenDate="chosenDate"
                @leaguesToShow="leaguesToShow"
                :leaguesForFilters="leaguesForFilters"
                :datesForFilters="datesForFilters"
                :chosenDateValue="chosenDateValue"
                :leaguesToShowData="leaguesToShowData"
                :loading="!gotData"
                @sortedBtts="sortByBtts"
                @sortedWinPercentage="sortByWinPercentage"
                @overTwoFive="sortByO25"
              />
            </div>
          </div>
          <template v-if="matchCount">
            <div
              class="relative"
              v-for="(competition, key) in APIDataWithFilters"
              :key="key"
              :class="{ 'z-10': key != 0 }"
            >
              <div v-if="competition">
                <Competition
                  :data="competition"
                  :mode="mode"
                  :oddsType="oddsType"
                  :subType="subscriptionType"
                />
              </div>
            </div>
            <div
              v-if="showBackToTop"
              class="fixed bottom-0 left-0 right-0 justify-center pb-4 items-center flex z-50"
            >
              <a href="#matches">
                <svg
                  width="176"
                  height="37"
                  viewBox="0 0 176 37"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <g filter="url(#filter0_d_323_362)">
                    <rect
                      x="5.63907"
                      width="165.057"
                      height="26.3488"
                      rx="13.1744"
                      fill="#838384"
                      shape-rendering="crispEdges"
                    />
                    <mask
                      id="mask0_323_362"
                      style="mask-type: alpha"
                      maskUnits="userSpaceOnUse"
                      x="16"
                      y="1"
                      width="24"
                      height="24"
                    >
                      <rect
                        x="39.1677"
                        y="24.5917"
                        width="22.8345"
                        height="22.8345"
                        transform="rotate(-180 39.1677 24.5917)"
                        fill="url(#pattern0)"
                      />
                    </mask>
                    <g mask="url(#mask0_323_362)">
                      <rect
                        x="35.2858"
                        y="22.1941"
                        width="14.9566"
                        height="15.7558"
                        transform="rotate(-180 35.2858 22.1941)"
                        fill="white"
                      />
                    </g>
                    <path
                      d="M40.9025 18.1744V7.06157H44.0536C45.0685 7.06157 45.8601 7.31528 46.4284 7.82272C47.0069 8.33015 47.2961 9.03548 47.2961 9.93872C47.2961 10.5476 47.149 11.0601 46.8547 11.4762C46.5604 11.8822 46.1493 12.1562 45.6216 12.2983C46.2204 12.4708 46.6923 12.8006 47.0374 13.2878C47.3824 13.7648 47.5549 14.3635 47.5549 15.0841C47.5549 16.0381 47.2606 16.7942 46.672 17.3523C46.0935 17.9004 45.2969 18.1744 44.282 18.1744H40.9025ZM42.2421 11.7959H44.0384C44.627 11.7959 45.0888 11.6386 45.4237 11.324C45.7688 11.0094 45.9413 10.5832 45.9413 10.0453C45.9413 9.5074 45.7738 9.08115 45.4389 8.76654C45.104 8.45193 44.6423 8.29463 44.0536 8.29463H42.2421V11.7959ZM42.2421 16.9413H44.1298C44.7691 16.9413 45.2715 16.7739 45.6368 16.439C46.0123 16.0939 46.2001 15.6271 46.2001 15.0384C46.2001 14.4295 46.0123 13.9373 45.6368 13.5618C45.2715 13.1761 44.7691 12.9833 44.1298 12.9833H42.2421V16.9413ZM49.0713 18.1744L51.9637 7.06157H53.8057L56.6828 18.1744H55.2975L54.5668 15.2211H51.2025L50.4718 18.1744H49.0713ZM51.4765 14.0642H54.2776L53.4251 10.639C53.2627 9.98946 53.1358 9.44651 53.0445 9.01011C52.9532 8.57372 52.8974 8.28956 52.8771 8.15762C52.8568 8.28956 52.8009 8.57372 52.7096 9.01011C52.6183 9.44651 52.4914 9.98439 52.329 10.6238L51.4765 14.0642ZM61.7614 18.3266C60.7465 18.3266 59.9447 18.0424 59.3561 17.4741C58.7675 16.9058 58.4732 16.1243 58.4732 15.1298V10.1062C58.4732 9.1116 58.7675 8.33015 59.3561 7.76182C59.9447 7.1935 60.7465 6.90934 61.7614 6.90934C62.7559 6.90934 63.5475 7.19857 64.1361 7.77705C64.7248 8.34537 65.0191 9.12175 65.0191 10.1062H63.649C63.649 9.47695 63.4816 8.99489 63.1467 8.65998C62.8219 8.31493 62.3601 8.1424 61.7614 8.1424C61.1626 8.1424 60.6907 8.30985 60.3456 8.64476C60.0107 8.97967 59.8433 9.46173 59.8433 10.0909V15.1298C59.8433 15.759 60.0107 16.2461 60.3456 16.5912C60.6907 16.9261 61.1626 17.0935 61.7614 17.0935C62.3601 17.0935 62.8219 16.9261 63.1467 16.5912C63.4816 16.2461 63.649 15.759 63.649 15.1298H65.0191C65.0191 16.1142 64.7248 16.8956 64.1361 17.4741C63.5475 18.0424 62.7559 18.3266 61.7614 18.3266ZM67.3575 18.1744V7.06157H68.7276V11.8264H70.3716L72.8378 7.06157H74.3296L71.5743 12.4048L74.4819 18.1744H72.9139L70.326 13.029H68.7276V18.1744H67.3575ZM87.4857 18.1744V8.30985H84.4411V7.06157H91.9003V8.30985H88.8557V18.1744H87.4857ZM96.9941 18.3266C95.9995 18.3266 95.213 18.0424 94.6345 17.4741C94.0561 16.9058 93.7668 16.1243 93.7668 15.1298V10.1062C93.7668 9.1116 94.0561 8.33015 94.6345 7.76182C95.213 7.1935 95.9995 6.90934 96.9941 6.90934C97.9887 6.90934 98.7752 7.1935 99.3537 7.76182C99.9322 8.32 100.221 9.09638 100.221 10.0909V15.1298C100.221 16.1243 99.9322 16.9058 99.3537 17.4741C98.7752 18.0424 97.9887 18.3266 96.9941 18.3266ZM96.9941 17.0935C97.5929 17.0935 98.0496 16.9261 98.3642 16.5912C98.6889 16.2461 98.8513 15.759 98.8513 15.1298V10.1062C98.8513 9.47695 98.6889 8.99489 98.3642 8.65998C98.0496 8.31493 97.5929 8.1424 96.9941 8.1424C96.4055 8.1424 95.9488 8.31493 95.624 8.65998C95.2993 8.99489 95.1369 9.47695 95.1369 10.1062V15.1298C95.1369 15.759 95.2993 16.2461 95.624 16.5912C95.9488 16.9261 96.4055 17.0935 96.9941 17.0935ZM113.956 18.1744V8.30985H110.911V7.06157H118.371V8.30985H115.326V18.1744H113.956ZM123.464 18.3266C122.47 18.3266 121.683 18.0424 121.105 17.4741C120.526 16.9058 120.237 16.1243 120.237 15.1298V10.1062C120.237 9.1116 120.526 8.33015 121.105 7.76182C121.683 7.1935 122.47 6.90934 123.464 6.90934C124.459 6.90934 125.245 7.1935 125.824 7.76182C126.402 8.32 126.692 9.09638 126.692 10.0909V15.1298C126.692 16.1243 126.402 16.9058 125.824 17.4741C125.245 18.0424 124.459 18.3266 123.464 18.3266ZM123.464 17.0935C124.063 17.0935 124.52 16.9261 124.834 16.5912C125.159 16.2461 125.322 15.759 125.322 15.1298V10.1062C125.322 9.47695 125.159 8.99489 124.834 8.65998C124.52 8.31493 124.063 8.1424 123.464 8.1424C122.876 8.1424 122.419 8.31493 122.094 8.65998C121.77 8.99489 121.607 9.47695 121.607 10.1062V15.1298C121.607 15.759 121.77 16.2461 122.094 16.5912C122.419 16.9261 122.876 17.0935 123.464 17.0935ZM129.121 18.1744V7.06157H132.699C133.734 7.06157 134.556 7.36095 135.165 7.95972C135.784 8.54835 136.094 9.33995 136.094 10.3345C136.094 11.3291 135.784 12.1258 135.165 12.7245C134.556 13.3132 133.734 13.6075 132.699 13.6075H130.491V18.1744H129.121ZM130.491 12.3744H132.699C133.298 12.3744 133.775 12.1917 134.13 11.8264C134.495 11.4509 134.678 10.9536 134.678 10.3345C134.678 9.7053 134.495 9.20801 134.13 8.84266C133.775 8.47731 133.298 8.29463 132.699 8.29463H130.491V12.3744Z"
                      fill="white"
                    />
                    <mask
                      id="mask1_323_362"
                      style="mask-type: alpha"
                      maskUnits="userSpaceOnUse"
                      x="137"
                      y="1"
                      width="24"
                      height="24"
                    >
                      <rect
                        x="160.002"
                        y="24.5917"
                        width="22.8345"
                        height="22.8345"
                        transform="rotate(-180 160.002 24.5917)"
                        fill="url(#pattern1)"
                      />
                    </mask>
                    <g mask="url(#mask1_323_362)">
                      <rect
                        x="156.12"
                        y="22.1941"
                        width="14.9566"
                        height="15.7558"
                        transform="rotate(-180 156.12 22.1941)"
                        fill="white"
                      />
                    </g>
                    <rect
                      x="6.07835"
                      y="0.439278"
                      width="164.179"
                      height="25.4702"
                      rx="12.7351"
                      stroke="#161616"
                      stroke-width="0.878557"
                      shape-rendering="crispEdges"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_323_362"
                      x="0.367728"
                      y="0"
                      width="175.6"
                      height="36.8915"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="5.27134" />
                      <feGaussianBlur stdDeviation="2.63567" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_323_362"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_323_362"
                        result="shape"
                      />
                    </filter>
                    <pattern
                      id="pattern0"
                      patternContentUnits="objectBoundingBox"
                      width="1"
                      height="1"
                    >
                      <use
                        xlink:href="#image0_323_362"
                        transform="scale(0.005)"
                      />
                    </pattern>
                    <pattern
                      id="pattern1"
                      patternContentUnits="objectBoundingBox"
                      width="1"
                      height="1"
                    >
                      <use
                        xlink:href="#image0_323_362"
                        transform="scale(0.005)"
                      />
                    </pattern>
                    <image
                      id="image0_323_362"
                      width="200"
                      height="200"
                      xlink:href="data:image/png;base64,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"
                    />
                  </defs>
                </svg>
              </a>
            </div>
          </template>
          <div
            v-else
            class="pt-28 pb-32 px-4 flex items-center justify-center relative lg:pb-96 border-t-2 border-gray-400"
          >
            <template v-if="gotData">
              <div
                class="relative z-10 w-full max-w-md text-center bg-white/30 border border-white/30 rounded-2xl shadow-xl backdrop-blur-sm p-5 md:p-10"
              >
                <template v-if="searchValue">
                  <h3 class="text-2xl font-bold uppercase text-gray-800">
                    No matches found 🔍
                  </h3>
                  <p class="mt-2 text-gray-500">
                    Nothing matches “{{ searchValue }}” in the games shown.
                  </p>
                  <button
                    type="button"
                    v-on:click="searchValue = ''"
                    class="mt-4 text-blue-700 font-bold uppercase underline"
                  >
                    Clear search
                  </button>
                </template>
                <template v-else>
                  <h3 class="text-2xl font-bold uppercase text-gray-800">
                    No matches found 🔍
                  </h3>
                  <p class="mt-2 text-gray-500">
                    No games meet your filters. Try changing them.
                  </p>
                </template>
              </div>
            </template>
            <Loader v-else />
          </div>
        </template>
      </template>
      <div v-if="!gotData">
        <template v-if="subscriptionType">
          <div v-if="error" class="p-10 pb-20 mx-auto max-w-6xl text-center">
            <!-- <div
            class="inset-0 absolute bg-pattern bg-center border-t-2 border-gray-400 bg-gray-100"
          ></div> -->
            <p class="relative z-10">
              <b>
                Sorry, we had an issue getting our data. Please try again later.
              </b>
            </p>
          </div>
          <div
            v-else
            class="py-32 flex items-center justify-center relative lg:pb-96"
          >
            <template v-if="gotData">
              <p class="relative z-10">
                <b>
                  There are no matches today unfortunately... yeah, we don't
                  know what to do with ourselves either...
                </b>
              </p>
            </template>
            <Loader v-else />
          </div>
        </template>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header";
import Intro from "./components/Intro";
import FiltersWrapper from "./components/FiltersWrapper";

import ClickOutside from "vue-click-outside";

import SubscriberIntro from "./components/SubscriberIntro";
import Loader from "./components/Loader";
// import Arrow from "@/assets/icons/Arrow";
// import Card from "./components/Card";

import Competition from "./components/Competition";

import Footer from "./components/Footer";
import API from "./api";

import _ from "lodash";
import FreemiumCard from "./components/FreemiumCard.vue";

export default {
  name: "Homepage",
  components: {
    Header,
    Loader,
    Intro,
    // BetOfTheDay,
    Competition,
    SubscriberIntro,
    Footer,
    // Arrow,
    FiltersWrapper,
    // Card,
    FreemiumCard,
  },
  data: function () {
    return {
      APIData: [],
      betOfTheDayData: [],
      numberMatches: 0,
      numberCompetitions: 0,
      error: false,
      mode: false,
      showSortDropdown: false,
      showOddsDropdown: false,
      oddsType: this.$store.getters.preferences.odds_format,
      gotData: false,
      mobileSearchHidden: true,
      searchValue: "",
      chosenDateValue: "",
      leaguesToShowData: [],
      showBackToTop: false,
      lastScrollPosition: 0,
      APITimestamp: false,
      showFilters: false,
      mobileMenuOpen: false,
      sortedBtts: false,
      sortedWinPercentage: false,
      emailMatch: false,
      leaguePrefsApplied: false,
      leaguePrefsNote: false,
    };
  },
  // do not forget this section
  directives: {
    ClickOutside,
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    this.applySlipLink();

    if (window.APIData) {
      this.APIData = window.APIData;
      this.gotData = true;
    } else {
      this.loadMatches(this.subscriptionType);
    }
    // if (window.betOfTheDayData) {
    //   this.betOfTheDayData = window.betOfTheDayData;
    // } else {
    //   this.getBetOfTheDay();
    // }

    if (this.$route.query && this.$route.query.stripe_response) {
      // eslint-disable-next-line no-undef
      gtag("event", `checkout_${this.$route.query.stripe_response}`);
      document.getElementById("footballmedia").src =
        "https://www.track-footballmedia.com/adclick.php";
      if (this.$route.query.stripe_response == "success") {
        setTimeout(function () {
          location.reload();
        }, 1000);
      }
    }

    if (this.subscriptionType && this.$route.path == "/") {
      this.$router.push("/predictions");
    }

    var text = document.getElementById("typewriter-header-upgrade");
    // eslint-disable-next-line no-undef
    var typewriter = new Typewriter(text, {
      loop: false,
      delay: 50,
    });

    typewriter
      .typeString("Scroll down to view the matches.")
      .pauseFor(500)
      .typeString(" Enjoying numbers_game?<br>")
      .pauseFor(750)
      .typeString("Upgrade for access to top leagues around the world.")
      .start();
  },

  methods: {
    async loadEmailMatch() {
      // /predictions?match=<key> from the daily email. Subscribers get the card opened by
      // Card.vue; for everyone else, show the match blurred when it is not in their own list.
      const key = this.$route.query.match;
      if (!key || this.subscriptionType == "active" || this.emailMatch) {
        return;
      }
      const loaded = _.some(
        Array.isArray(this.APIData) ? this.APIData : [this.APIData || {}],
        (item) => _.some(item.matches, (match) => match.key == key),
      );
      if (loaded) {
        return;
      }
      const response = await API.get(
        `/match?matchKey=${encodeURIComponent(key)}`,
      ).catch(() => false);
      if (!response || !response.data || !response.data.home_team) {
        return;
      }
      // Same shape as the blurred cards in the freemium package: no predictions, no odds.
      const info = response.data;
      this.emailMatch = {
        ..._.pick(info, [
          "key",
          "title",
          "competition",
          "competition_logo",
          "commencing",
          "date",
          "time",
          "stage",
          "round",
          "tvstations",
        ]),
        home_team: _.pick(info.home_team, ["name", "team_id", "logo"]),
        away_team: _.pick(info.away_team, ["name", "team_id", "logo"]),
        draw: {},
      };
      this.$nextTick(() => {
        this.$refs.emailMatch.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      });
    },
    bubbleFilters(payload) {
      this.showFilters = payload;
    },
    toggleMobileMenu(payload) {
      this.mobileMenuOpen = payload;
    },
    onScroll() {
      if (window.scrollY >= 500) {
        const currentScrollPosition = window.scrollY;
        if (currentScrollPosition < this.lastScrollPosition) {
          this.showBackToTop = true;
        } else {
          this.showBackToTop = false;
        }
        this.lastScrollPosition = currentScrollPosition;
      } else {
        this.showBackToTop = false;
      }
    },
    scrollToNextGame() {
      const givenTimestamp = this.APITimestamp;
      const matches = document.querySelectorAll("[data-match-commencing]");
      const timestampsArray = Array.from(matches).map((element) =>
        element.getAttribute("data-match-commencing"),
      );
      const numericTimestamps = timestampsArray.map(Number);
      // Function to find the first timestamp greater than the given timestamp
      function findFirstTimestampAfterGivenID(arr, givenID) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i] > givenID) {
            return arr[i];
          }
        }
        // If no timestamp is greater than the givenID, return null or any desired value.
        return null;
      }

      // Call the function to find the first timestamp after the given timestamp
      const firstTimestampAfterGivenID = findFirstTimestampAfterGivenID(
        numericTimestamps,
        givenTimestamp,
      );

      const element = document.querySelector(
        `[data-match-commencing="${firstTimestampAfterGivenID}"]`,
      );
      element.scrollIntoView({ behavior: "smooth" });
    },
    leaguesToShow(payload) {
      this.leaguesToShowData = payload;
      this.leaguePrefsNote = false;
    },
    // Open on the member's preferred leagues once per visit; the Filter panel still overrides it.
    applyLeaguePreferences() {
      if (
        this.leaguePrefsApplied ||
        this.subscriptionType != "active" ||
        !this.gotData ||
        !this.leaguesForFilters.length
      ) {
        return;
      }
      this.leaguePrefsApplied = true;
      const ids = this.$store.getters.preferences.leagues;
      if (!ids.length) return;
      // Match on league_id where the card has one (card names can differ from the
      // league list, e.g. "Enterprise National League"); fall back to the name.
      const names = this.$store.getters.preferredLeagueNames;
      const showing = [];
      _.forEach(this.APIData, (item) => {
        _.forEach(item.matches, (match) => {
          const preferred =
            match.league_id != null
              ? ids.includes(Number(match.league_id))
              : names.includes(match.competition);
          if (preferred && !showing.includes(match.competition)) {
            showing.push(match.competition);
          }
        });
      });
      this.leaguesToShowData = showing;
      this.leaguePrefsNote = showing.length ? "showing" : "none";
    },
    // ?slip=<id1>,<id2> prefills the bet slip (links from emails and shared posts)
    applySlipLink() {
      // a shared link is untrusted: ?slip=a&slip=b arrives as an array, and a stray % won't decode
      const raw = [].concat(this.$route.query.slip || "")[0];
      const ids = String(raw || "").split(",").filter(Boolean);
      if (!ids.length || !this.subscriptionType) return;
      const decode = (id) => {
        try {
          return decodeURIComponent(id);
        } catch (e) {
          return null;
        }
      };
      const legs = ids.map(decode).filter(Boolean).map((id) => ({ id }));
      if (legs.length) this.$store.dispatch("betslip/prefill", legs);
    },
    openSlip() {
      this.$store.dispatch("betslip/open", true);
    },
    showAllLeagues() {
      this.leaguesToShowData = [];
      this.leaguePrefsNote = false;
    },
    chosenDate(payload) {
      this.chosenDateValue = payload;
    },
    hideMobileSearch() {
      this.mobileSearchHidden = true;
    },
    toggleMobileSearchOrSubmit() {
      this.mobileSearchHidden = !this.mobileSearchHidden;
      if (!this.mobileSearchHidden) {
        let el = this.$refs.focusSearch[0];
        let timeout = 200;

        // Align temp input element approximately where the input element is
        // so the cursor doesn't jump around
        var __tempEl__ = document.createElement("input");
        __tempEl__.style.position = "absolute";
        __tempEl__.style.top = el.offsetTop + 7 + "px";
        __tempEl__.style.left = el.offsetLeft + "px";
        __tempEl__.style.height = 0;
        __tempEl__.style.opacity = 0;
        // Put this temp element as a child of the page <body> and focus on it
        document.body.appendChild(__tempEl__);
        __tempEl__.focus();

        // The keyboard is open. Now do a delayed focus on the target element
        setTimeout(function () {
          el.focus();
          el.click();
          // Remove the temp element
          document.body.removeChild(__tempEl__);
        }, timeout);
      }
    },
    toggleSortDropdown() {
      this.showSortDropdown = !this.showSortDropdown;
    },
    toggleOddsDropdown() {
      this.showOddsDropdown = !this.showOddsDropdown;
    },
    handleSignUp(event) {
      event.currentTarget.click();
    },
    toggleLoginModal() {
      document.getElementById("loginbutton").click();
    },
    fractionalOdds() {
      this.oddsType = "fraction";
      this.showOddsDropdown = false;
      this.$forceUpdate();
    },
    decimalOdds() {
      this.oddsType = "decimal";
      this.showOddsDropdown = false;
      this.$forceUpdate();
    },
    async loadMatches(subscriptionType) {
      if (subscriptionType == false) {
        const response = await API.get("/matches/free/open").catch(() => {
          this.error = true;
        });
        let responseData = response ? response.data : false;
        this.APIData = responseData ? responseData : false;
        this.APITimestamp = response.data.timestamp
          ? response.data.timestamp
          : false;
        this.gotData = true;
      } else {
        var api_url;
        if (subscriptionType == "inactive") {
          api_url = "/matches/freemium";
        } else {
          api_url = "/matches/premium/chrono";
        }
        this.APIData = [];
        this.gotData = false;
        this.showSortDropdown = false;

        let auth = {
          idToken: this.$store.getters.accessTokens["id_token"],
        };
        const response = await API.get(api_url, auth).catch(() => {
          this.error = true;
        });
        this.mode = "chrono";
        let responseData = response ? response.data : false;
        let responseArray = [];
        _.forEach(responseData.dates, (date, key) => {
          responseArray.push({ matches: date, date: key });
        });
        this.gotData = true;
        this.APIData = responseArray;
        this.APITimestamp = response.data.timestamp
          ? response.data.timestamp
          : false;
        this.numberMatches = responseData.matches_today;
        this.numberCompetitions = responseData.competitions_today;
        this.oddsType = this.$store.getters.preferences.odds_format;
      }
    },
    async getLeagues(subscriptionType) {
      subscriptionType = subscriptionType
        ? subscriptionType
        : this.subscriptionType;

      if (subscriptionType == false) {
        const response = await API.get("/matches/free/open").catch(() => {
          this.error = true;
        });
        let responseData = response ? response.data : false;
        this.APIData = responseData ? responseData : false;
        this.APITimestamp = response.data.timestamp
          ? response.data.timestamp
          : false;

        this.gotData = true;
      }
      if (subscriptionType == "inactive") {
        const response = await API.get("/matches/free/open").catch(() => {
          this.error = true;
        });
        let responseData = response ? response.data : false;
        this.APIData = responseData ? responseData : false;
        this.APITimestamp = response.data.timestamp
          ? response.data.timestamp
          : false;

        this.gotData = true;
      }
      if (subscriptionType == "active") {
        this.mode = "league";
        this.APIData = [];
        this.gotData = false;
        this.showSortDropdown = false;
        let auth = {
          idToken: this.$store.getters.accessTokens["id_token"],
        };
        const response = await API.get("/matches/premium", auth).catch(() => {
          this.error = true;
        });
        let responseData = response ? response.data : false;
        this.APIData = responseData ? responseData.competitions : false;
        this.APITimestamp = response.data.timestamp
          ? response.data.timestamp
          : false;

        this.gotData = true;
      }
    },
    async getChrono() {
      this.APIData = [];
      this.gotData = false;
      this.showSortDropdown = false;

      let auth = {
        idToken: this.$store.getters.accessTokens["id_token"],
      };
      const response = await API.get("/matches/premium/chrono", auth).catch(
        () => {
          this.error = true;
        },
      );
      this.mode = "chrono";
      let responseData = response ? response.data : false;
      let responseArray = [];
      _.forEach(responseData.dates, (date, key) => {
        responseArray.push({ matches: date, date: key });
      });
      this.gotData = true;
      this.APIData = responseArray;
      this.APITimestamp = response.data.timestamp
        ? response.data.timestamp
        : false;
    },
    async getToday() {
      this.APIData = [];
      this.gotData = false;
      this.showSortDropdown = false;
      let auth = {
        idToken: this.$store.getters.accessTokens["id_token"],
      };
      const response = await API.get("/matches/premium/today", auth).catch(
        () => {
          this.error = true;
        },
      );
      this.mode = "today";
      let responseData = response ? response.data : false;
      let responseArray = [];
      _.forEach(responseData.dates, (date, key) => {
        responseArray.push({ matches: date, date: key });
      });
      this.gotData = true;
      this.APIData = responseArray;
      this.APITimestamp = response.data.timestamp
        ? response.data.timestamp
        : false;
    },
    async sortByBtts() {
      this.sortedBtts = true;

      if (this.sortedBtts == true) {
        this.gotData = false;
        this.APIData = [];
        let auth = {
          idToken: this.$store.getters.accessTokens["id_token"],
        };

        const response = await API.get("/matches/sorted/btts", auth).catch(
          () => {
            this.error = true;
          },
        );

        this.mode = "btts";

        let responseData = response ? response.data : false;
        let responseArray = [];
        _.forEach(responseData.dates, (date, key) => {
          responseArray.push({ matches: date, date: key });
        });
        this.APIData = responseArray;
        this.gotData = true;
      }
    },
    async sortByO25() {
      this.overTwoFive = true;

      if (this.overTwoFive == true) {
        this.gotData = false;
        this.APIData = [];
        let auth = {
          idToken: this.$store.getters.accessTokens["id_token"],
        };

        const response = await API.get("/matches/sorted/25", auth).catch(() => {
          this.error = true;
        });

        this.mode = "over2.5";

        let responseData = response ? response.data : false;
        let responseArray = [];
        _.forEach(responseData.dates, (date, key) => {
          responseArray.push({ matches: date, date: key });
        });
        this.APIData = responseArray;
        this.gotData = true;
      }
    },
    generateSearchResults() {
      if (!this.searchValue) {
        return this.APIData;
      }
      // Strip accents so "bes" finds "Beşiktaş", "sao" finds "São Paulo"
      const fold = (text) =>
        text
          .normalize("NFD")
          .replace(/[̀-ͯ]/g, "")
          .toLowerCase()
          .replace(/ı/g, "i")
          .replace(/[øœ]/g, "o")
          .replace(/ł/g, "l")
          .replace(/đ/g, "d")
          .replace(/ß/g, "ss")
          .replace(/æ/g, "ae");
      const query = fold(this.searchValue);
      let searchMatches = [];
      _.forEach(this.APIData, (date, key) => {
        searchMatches[key] = {
          date: this.APIData[key].date,
          matches: [],
        };
        _.forEach(date.matches, (match) => {
          if (
            fold(match.title).includes(query) ||
            fold(match.competition).includes(query)
          ) {
            searchMatches[key].matches.push(match);
          }
        });
      });
      return searchMatches;
    },
    async sortByWinPercentage() {
      this.sortedWinPercentage = true;
      if (this.sortedWinPercentage == true) {
        this.gotData = false;
        this.APIData = [];
        let auth = {
          idToken: this.$store.getters.accessTokens["id_token"],
        };

        const response = await API.get("/matches/sorted", auth).catch(() => {
          this.error = true;
        });

        this.mode = "win";

        let responseData = response ? response.data : false;
        let responseArray = [];
        _.forEach(responseData.dates, (date, key) => {
          responseArray.push({ matches: date, date: key });
        });
        this.APIData = responseArray;
        this.gotData = true;
      }
    },
  },
  watch: {
    APIData() {
      window.APIData = this.APIData;
    },
    gotData() {
      if (this.gotData) {
        this.loadEmailMatch();
        this.applyLeaguePreferences();
      }
    },
    // searchValue() {
    //   // console.log("Search value is: ", this.searchValue);
    //   // console.log("API data is: ", this.APIData);
    //   this.generateSearchResults();
    // },
    // betOfTheDayData() {
    //   window.betOfTheDayData = this.betOfTheDayData;
    // },
    subscriptionType() {
      this.APIData = [];
      this.gotData = false;
      window.APIData = [];
      // this.betOfTheDayData = [];
      // window.betOfTheDayData = [];
      this.getLeagues(this.subscriptionType);
      // this.getBetOfTheDay();
    },
    mode() {
      if (this.mode == "today") {
        this.chosenDateValue = "";
        this.leaguesToShowData = [];
        this.leaguePrefsNote = false;
      }
    },
  },
  computed: {
    matchCount() {
      return _.sumBy(this.APIDataWithFilters, (obj) =>
        obj ? obj.matches.length : false,
      );
    },
    leaguesForFilters() {
      let leagues = [];
      _.forEach(this.APIData, (item) => {
        _.forEach(item.matches, (match) => {
          leagues.push(match.competition);
        });
      });
      // return _.uniq(leagues);
      return _.map(_.uniq(leagues), (item) => ({ title: item }));
    },
    datesForFilters() {
      if (this.mode == "league") {
        let items = [];
        _.forEach(this.APIData, (item) => {
          _.forEach(item.matches, (match) => {
            items.push(match.date);
          });
        });
        return _.uniq(items);
      } else {
        let items = [];
        _.forEach(this.APIData, (item) => {
          items.push(item.date);
        });
        return _.uniq(items);
      }
    },
    subscriptionType() {
      // return "inactive";
      return this.$store.getters.subscriptionType;
    },
    APIDataSorted() {
      return _.sortBy(this.APIDataSearched, "date");
    },
    APIDataWithFilters() {
      // This is insanely complicated but will try to tidy up later.
      // eslint-disable-next-line no-undef
      gtag("event", "filter_button", {
        event_category: "engagement",
        event_label: "filter_button",
      });

      // 1. Get chosen date from filters. If chosen date, we can only display the matches from that date.
      let convertedDate = this.chosenDateValue
        ? this.chosenDateValue.toISOString().substring(0, 10)
        : false;

      // 2. If we are showing by league, the data is a little diferent, so filter out.
      if (this.mode == "league") {
        // 2.1 If we have a date, use it to only show matches from that date.
        if (convertedDate) {
          let convertedWithDate = _.map(this.APIDataSorted, (item) => {
            return {
              ...item,
              matches: item.matches
                ? _.filter(item.matches, { date: convertedDate })
                : [],
            };
          });

          // 3.2 If we have a filtered league list, use it to only show matches from that league.
          if (this.leaguesToShowData.length) {
            console.log("We have a date and we have leagues");
            const filteredData = _.map(convertedWithDate, (item) => {
              return {
                ...item,
                matches: item.matches
                  ? _.filter(item.matches, (match) => {
                      return _.includes(
                        this.leaguesToShowData,
                        match.competition,
                      );
                    })
                  : [],
              };
            });

            return filteredData;
          } else {
            return convertedWithDate;
          }
        } else {
          if (this.leaguesToShowData.length) {
            const filteredData = _.map(this.APIDataSorted, (item) => {
              return {
                ...item,
                matches: item.matches
                  ? _.filter(item.matches, (match) => {
                      return _.includes(
                        this.leaguesToShowData,
                        match.competition,
                      );
                    })
                  : [],
              };
            });
            return filteredData;
          } else {
            return this.APIDataSorted;
          }
        }
      } else {
        // 3. If we are showing by any other mode, filter it here.
        // 3.1 If we have a date, use it to only show matches from that date.
        if (convertedDate) {
          let convertedWithDate = _.filter(this.APIDataSorted, {
            date: convertedDate,
          });
          // 3.2 If we have a filtered league list, use it to only show matches from that league.
          if (this.leaguesToShowData.length) {
            const filteredData = _.map(convertedWithDate, (item) => {
              return {
                ...item,
                matches: item.matches
                  ? _.filter(item.matches, (match) => {
                      return _.includes(
                        this.leaguesToShowData,
                        match.competition,
                      );
                    })
                  : [],
              };
            });
            return filteredData;
          } else {
            // 3.3. Return everything.
            return convertedWithDate;
          }
        } else {
          // 3.4 No date, so just filter by leagues if they exist
          if (this.leaguesToShowData.length) {
            const filteredData = _.map(this.APIDataSorted, (item) => {
              return {
                ...item,
                matches: item.matches
                  ? _.filter(item.matches, (match) => {
                      return _.includes(
                        this.leaguesToShowData,
                        match.competition,
                      );
                    })
                  : [],
              };
            });
            return filteredData;
          } else {
            return this.APIDataSorted;
          }
        }
      }
    },
    APIDataSearched() {
      return this.generateSearchResults();
    },
    APIDataGroupedFree() {
      let groupByDateTime = {};
      _.forEach(this.APIData, (match) => {
        const dateKey = match.date;
        const timeKey = match.time;
        if (!groupByDateTime[dateKey]) {
          groupByDateTime[dateKey] = {};
        }
        if (!groupByDateTime[dateKey][timeKey]) {
          groupByDateTime[dateKey][timeKey] = [];
        }
        groupByDateTime[dateKey][timeKey].push(match);
      });
      return groupByDateTime;
    },
    nextMatch() {
      // _.forEach(this.APIData[0].matches, (match, key) => {
      //   console.log(match, key)
      // });
      return this.APIData.matches
        ? this.APIData.matches[0]
        : this.APIData.matches;
    },
  },
};
</script>

<style>
/* Page wrapper with unified background */
.page-wrapper {
  min-height: 100vh;
}

.grid-lines {
  --s: 80px;
  --n: 4;
  --t: 2px;
  --g: 10px;
  --c: rgba(85, 98, 112, 0.05) 25%, #0000 0;
  background:
    conic-gradient(at var(--g) var(--t), var(--c))
      calc((var(--s) / var(--n) - var(--g) + var(--t)) / 2) 0 /
      calc(var(--s) / var(--n)) var(--s),
    conic-gradient(from 180deg at var(--t) var(--g), var(--c)) 0
      calc((var(--s) / var(--n) - var(--g) + var(--t)) / 2) / var(--s)
      calc(var(--s) / var(--n)),
    linear-gradient(135deg, #f8fafc 0%, #90aaff9d 50%, #f0f4f9 100%);
}

/* the site's primary CTA (see Intro.vue) */
.email-cta {
  background: linear-gradient(90deg, #1966ff, #5036ff, #1554ff, #402fff);
  background-size: 300% 100%;
  animation: email-cta-shift 3s ease-in-out infinite;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}
.email-cta:hover {
  transform: translateY(-2px);
  box-shadow:
    0 8px 25px rgba(25, 102, 255, 0.4),
    0 4px 15px rgba(80, 54, 255, 0.3);
}
@keyframes email-cta-shift {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}
</style>
